module.exports = __webpack_public_path__ + "static/pastelfloralhamper-f28423aedc7dd872775069bd3f0e3e27.jpeg";